var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25977,
    y: 3.64404,
    width: 45.4779,
    height: 38.8382,
    rx: 3.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M1.88477 7.59125C1.88477 5.9269 3.23962 4.58068 4.90393 4.59131L43.9578 4.84082C45.1213 4.84825 46.0329 5.84339 45.9385 7.00303L45.8229 8.42281V11.9434H1.88477V7.59125Z",
    fill: "#858585"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.84375,
    y: 15.8165,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5859,
    y: 16.1284,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8926 21.3158L23.9585 23.1581L27.867 19.2497",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2949,
    y: 15.8165,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.84375,
    y: 29.0981,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2715,
    y: 29.0957,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2949,
    y: 29.0957,
    width: 10.0662,
    height: 10.0662,
    rx: 5.03309,
    fill: "#A8A8A8",
    stroke: "#A8A8A8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8267,
    y: 0.931152,
    width: 2.21362,
    height: 5.53405,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9595,
    y: 0.928833,
    width: 2.21362,
    height: 5.53405,
    fill: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 0.759766,
    y: 11.9956,
    width: 46.4779,
    height: 1.10681,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDateIcon);
export default __webpack_public_path__ + "static/media/selectDateIcon.7d8e8742b11fcf2b4478373ffcb9ee3b.svg";
export { ForwardRef as ReactComponent };